import React, { useEffect, useState } from 'react';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import CSSModule from 'react-css-modules';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { AppWrapper, Block, Button } from 'components';
import AffiliateBusinessModal from 'components/AffiliateBusinessModal/AffiliateBusinessModal';
import Breadcrumbs from 'components/BreadCrumbs/BreadCrumbs';
import { actions as affiliateActions } from 'coupon-common/src/modules/affiliateBusiness';

import styles from './AffiliateBusinessManager.module.scss';
import messages from './messages';

const AffiliateBusinessManager = ({ intl, dispatch, affiliateBusinessesData }) => {

  const [affiliateBusinesses, setAffiliateBusinesses] = useState([]);
  const [paginationOptions, setPaginationOptions] = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [editingBusiness, setEditingBusiness] = useState(null);

  const fetchAffiliates = () =>{
    dispatch(affiliateActions.getAffiliateBusinesses());
  }

  useEffect(() => {
    fetchAffiliates()
  }, [])

  useEffect(()=>{
    if(affiliateBusinessesData?.results){
      setAffiliateBusinesses(affiliateBusinessesData.results)
    }
  }, [affiliateBusinessesData])

  useEffect(()=>{

  }, [])

  const columns = [
    {
      dataField: 'id',
      text: intl.formatMessage(messages.idColumnText), // now uses idColumnText
      sort: true,
    },
    {
      dataField: 'name',
      text: intl.formatMessage(messages.businessColumnText),
      sort: true,
    },
    {
      dataField: 'business_web_url',
      text: intl.formatMessage(messages.businessWebUrlColumnText), // renamed properly
      sort: true,
    },
    {
      dataField: ' ',
      text: ' ',
      classes: styles['btn'],
      formatter: () => intl.formatMessage(messages.editColumnText),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handleEdit(row)
        },
      },
    },
    {
      dataField: ' ',
      text: ' ',
      classes: styles['btn'],
      formatter: () => intl.formatMessage(messages.deleteColumnText),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handleDelete(row.id)
        },
      },
    },
  ];

  useEffect(() => {
    const options = {
      sizePerPage: 25,
      totalSize: affiliateBusinesses?.length,
      showTotal: true,
      sizePerPageList: [10, 25, 50, 100],
      firstPageText: 'First',
      lastPageText: 'Last',
      nextPageText: 'Next',
      prePageText: 'Previous',
      withFirstAndLast: true,
    };

    setPaginationOptions(options);
  }, [affiliateBusinesses]);

  const handleOpenCreate = () => {
    setEditingBusiness(null); // null means creating new
    setModalOpen(true);
  };

  const handleEdit = (business) => {
    setEditingBusiness(business);
    setModalOpen(true);
  };

const handleDelete = (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this business?");

  if (confirmDelete) {
    dispatch(affiliateActions.deleteAffiliateBusiness(id));
    // fetchAffiliates()
  }
};

  const handleSave = (data) => {
    if (editingBusiness) {
      dispatch(affiliateActions.updateAffiliateBusiness(editingBusiness.id, data));
    } else {
      dispatch(affiliateActions.createAffiliateBusiness(data));
    }
    setModalOpen(false);
    // fetchAffiliates()
  };



  return (
    <AppWrapper
      showHeader
      showSideNav
      showHeadingRow
      headingText={intl.formatMessage(messages.pageHeadingText)}
    >
      <div className="col-md-12">
        <Breadcrumbs locationArray={['Admin', 'Affiliate Business Manager']} />
        <Block>
          <div className='d-flex justify-content-end'>
            <Button onClick={handleOpenCreate}>Create Affiliate Business +</Button>
          </div>
          <div styleName="table-container" className="table-container overflow-auto">
            <BootstrapTable
              classes="table-borderless mb-0 overflow-auto custom-react-bootstrap-table ml-0 mr-0"
              striped
              bordered={false}
              bootstrap4
              keyField="id"
              data={affiliateBusinesses}
              columns={columns}
              pagination={paginationFactory(paginationOptions)}
            />
          </div>
        </Block>
      </div>
      <AffiliateBusinessModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        business={editingBusiness}
      />

    </AppWrapper>
  );
};

const mapStateToProps = state => {
  return {
    affiliateBusinessesData: state?.affiliateBusiness?.data
  };
};

export default connect(mapStateToProps)(injectIntl(CSSModule(AffiliateBusinessManager, styles)),);
